var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClientMgmtMark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-860 -2261)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 24,
    height: 24,
    transform: "translate(860 2261)",
    fill: "#ffc051",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "check",
    d: "M6.893,14.114a.919.919,0,0,1-1.3,0L.4,8.924a1.378,1.378,0,0,1,0-1.949l.65-.65A1.378,1.378,0,0,1,3,6.325l3.24,3.24L15,.81a1.378,1.378,0,0,1,1.949,0l.65.65a1.378,1.378,0,0,1,0,1.949Zm0,0",
    transform: "translate(863 2265.594)",
    fill: "#ffc051"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientMgmtMark);
export default __webpack_public_path__ + "static/media/clientMgmtMark.ba2b0fc5e7e224acaa683d17fd0ce7b5.svg";
export { ForwardRef as ReactComponent };